import React from 'react';
import { Button, message } from 'antd';

export default function BotonesPedidolc({ onPedir, disabledPedir, loadingPedir }) {
  return (
    <div className="botones-pedidoslc">
      <Button loading={loadingPedir} disabled={disabledPedir} type="primary" onClick={() => onPedir()}>Pedir ahora</Button>
    </div>
  );
}
